import {
  booleanAttribute,
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
  output,
} from '@angular/core';
import { IconComponent } from '@softline/ui-core';
import { PrevCurrNextNavigationSize } from './prev-curr-next-navigation.types';

@Component({
  selector: 'soft-prev-curr-next-navigation, soft-ds-prev-curr-next-navigation',
  templateUrl: './prev-curr-next-navigation.component.html',
  styleUrls: ['./prev-curr-next-navigation.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [IconComponent],
  host: {
    '[class]': 'hostClasses()',
  },
})
export class PrevCurrNextNavigationComponent {
  readonly size = input<PrevCurrNextNavigationSize>('md');
  readonly disabled = input<boolean, unknown>(false, {
    transform: booleanAttribute,
  });
  readonly bordered = input<boolean, unknown>(true, {
    transform: booleanAttribute,
  });

  readonly previous = output<void>();
  readonly today = output<void>();
  readonly next = output<void>();

  protected readonly hostClasses = computed(
    () =>
      `soft-ds-prev-curr-next-navigation-host size-${this.size()}${this.bordered() ? ' is-bordered' : ''}`
  );
}
